import React from 'react';
import {Button, Form, Input, message, Tabs} from 'antd';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {AuthorizeApi, UserApi} from '../../scaffold';
import {useInput} from 'react-hanger';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import useAuth from '../../utils/AuthContext';
import CountDownButton from '../CountDownButton';
import Flex from '../Flex';

export default function LoginForm(props: {onClose: () => any}) {
  const loginHook = useOpenApiFpRequest(AuthorizeApi, AuthorizeApi.prototype.authorizeLoginPost);
  const loginByTelHook = useOpenApiFpRequest(AuthorizeApi, AuthorizeApi.prototype.authorizeLoginByTelPost);
  const telephone = useInput('');
  const password = useInput('');
  const code = useInput('');
  const auth = useAuth();
  const requestSms = useOpenApiFpRequest(UserApi, UserApi.prototype.userRequestSmsCodePost);

  function login() {
    loginHook
      .request({authorizeLoginParams: {telephone: telephone.value, password: password.value}})
      .then(response => {
        if (response.user) {
          auth.setCurrentUser(response.user);
        }
        if (response.body) {
          localStorage.setItem('Application-Token', response.body);
          auth.setToken(response.body);
        }
        message.success('登录成功');
        props.onClose();
      })
      .catch(CommonApiErrorHandler);
  }
  function loginByTel() {
    loginByTelHook
      .request({authorizeLoginByTelParams: {telephone: telephone.value, code: code.value}})
      .then(response => {
        if (response.user) {
          auth.setCurrentUser(response.user);
        }
        if (response.body) {
          localStorage.setItem('Application-Token', response.body);
          auth.setToken(response.body);
        }
        message.success('登录成功');
        props.onClose();
      })
      .catch(CommonApiErrorHandler);
  }
  return (
    <div>
      <Tabs style={{marginBottom: 32}}>
        <Tabs.TabPane tab={'密码登录'} key={'密码登录'}>
          <Form labelCol={{span: 4}}>
            <Form.Item label={'手机号'} required>
              <Input size={'large'} placeholder={'请输入手机号'} {...telephone.eventBind} />
            </Form.Item>
            <Form.Item label={'密码'} required>
              <Input.Password size={'large'} placeholder={'请输入密码'} {...password.eventBind} />
            </Form.Item>
          </Form>
          <Button size={'large'} type={'primary'} block className={'m-t-20'} loading={loginHook.loading} onClick={login}>
            登录
          </Button>
        </Tabs.TabPane>
        <Tabs.TabPane tab={'手机号登录'} key={'手机号登录'}>
          <Form labelCol={{span: 4}}>
            <Form.Item label={'手机号'} required>
              <Input size={'large'} placeholder={'请输入手机号'} {...telephone.eventBind} />
            </Form.Item>
            <Form.Item label={'验证码'} required>
              <Flex>
                <Input placeholder={'请输入短信验证码'} {...code.eventBind} />
                <CountDownButton
                  title={'立即获取'}
                  loading={requestSms.loading}
                  onClick={() => requestSms.request({requestSmsCodeParams: {telephone: telephone.value}})}
                  countDown={60}
                />
              </Flex>
            </Form.Item>
          </Form>
          <Button size={'large'} type={'primary'} block className={'m-t-20'} loading={loginHook.loading} onClick={loginByTel}>
            登录
          </Button>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}
